const DepartmentRoutes = [
  {
    icon: '',
    path: '/departments',
    name: 'Departments',
    component: () => import('@/pages/department/DepartmentList.vue'),
    meta: {
      auth: true,
      roles: ['admin', 'super_admin']
    }
  }
];

export default DepartmentRoutes;